import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    min_price: null,
    max_price: null,
    orderingName: '', //for user
    ordering: '', //for db
    trigger: null,
    searchValue: ''
}

const filtersForCustomerSlice = createSlice({
    name: 'filtersForCustomerSlice',
    initialState,
    reducers: {
        setMinPrice: (state, action) => {
            state.min_price = action.payload;
        },
        setMaxPrice: (state, action) => {
            state.max_price = action.payload;
        },
        setOrdering: (state, action) => {
            const {name, ordering} = action.payload;
            state.orderingName = name;
            state.ordering = ordering;
        },
        setTrigger: (state, action) => {
            state.trigger = !state.trigger;
        },
        setSearchValue: (state, action) => {
            state.searchValue = action.payload;
        },
        clearFilters: (state, action) => {
            state.min_price = null;
            state.max_price = null;
            state.orderingName = '';
            state.ordering = '';
        }
    },
});

const {actions, reducer: filtersForCustomerReducer} = filtersForCustomerSlice;

const filtersForCustomerActions = {
    ...actions,
}

export {
    filtersForCustomerActions,
    filtersForCustomerReducer,
}
